import { Component, inject, resource } from '@angular/core';
import { IBbitSelectDataRow } from '@bbitgmbh/bbit.utils';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { LoadingComponent } from '../../helper/loading/loading.component';
import { CompanionsService } from './companions.service';

@Component({
  selector: 'app-companions',
  templateUrl: './companions.component.html',
  styleUrl: './companions.component.scss',
  imports: [LoadingComponent, I18nPipe],
})
export class CompanionsComponent {
  public service = inject(CompanionsService);
  public companions = resource<IBbitSelectDataRow[], void>({
    loader: async () => {
      return await this.service.list();
    },
  });

  async editCompanion(_id: string): Promise<void> {
    const result = await this.service.editCompanion(_id);
    if (result.reload) {
      this.companions.reload();
    }
  }

  async addCompanion(): Promise<void> {
    const result = await this.service.addCompanion();
    if (result.reload) {
      this.companions.reload();
    }
  }
}
